export default [
    {
		path: '/my-network/:tab?',
		name: 'My Network',
		component: () => import('@/views/team/MyNetwork.vue'),
		props: route => {
			return {
				tab: route.params.tab,
				me: true,
				workspace: false,
				title: 'My Network',
			}
		},
		meta: {
			layout: 'Default',
			abilities: [
				['manage', 'mynetwork']
			],
			nav: 'my-network',
		},
	},
	{
		path: '/global-network/:tab?',
		name: 'Global Network',
		component: () => import('@/views/team/MyNetwork.vue'),
		props: route => {
			return {
				tab: route.params.tab,
				me: false,
				workspace: true,
				title: 'Global Network',
			}
		},
		meta: {
			layout: 'Default',
			abilities: [
				['manage', 'workspace-members']
			],
			nav: 'global-network',
		}
	}
]